import { formElement } from "../../forms/FormElement";
import HotWorkCategoryOneOptionsFormState from "../../forms/Permits/EnergyHarbourPermit/HotWorkCategoryOneOptionsFormState";

export type HotWorkCategoryOneOptions = {
    angleGrinder: boolean;
    cuttingTorch: boolean;
    welding: boolean;
    plasmaCutter: boolean;
    hotAirGun: boolean;
    gasBurner: boolean;
    openFlameSoldering: boolean;
    other: string;
};

export default HotWorkCategoryOneOptions;

export function HotWorkCategoryOneOptions_toFormState(
    hotWorkCategoryOneOptions: HotWorkCategoryOneOptions
): HotWorkCategoryOneOptionsFormState {
    return {
        angleGrinder: formElement(hotWorkCategoryOneOptions.angleGrinder),
        cuttingTorch: formElement(hotWorkCategoryOneOptions.cuttingTorch),
        welding: formElement(hotWorkCategoryOneOptions.welding),
        plasmaCutter: formElement(hotWorkCategoryOneOptions.plasmaCutter),
        hotAirGun: formElement(hotWorkCategoryOneOptions.hotAirGun),
        gasBurner: formElement(hotWorkCategoryOneOptions.gasBurner),
        openFlameSoldering: formElement(hotWorkCategoryOneOptions.openFlameSoldering),
        other: formElement(hotWorkCategoryOneOptions.other)
    };
}